import { GenIcon, IconType } from 'react-icons/lib';

const UfpbImagePortraitSlash: IconType = (props: any) =>
  GenIcon({
    attr: {
      viewBox: '0 0 512 512',
    },
    child: [
      {
        attr: {
          d: 'M 112 0 C 86.710419 0 66.037842 19.569409 64.183594 44.384766 L 30.458984 10.660156 C 26.855003 7.0561745 20.405855 7.70352 15.998047 12.111328 L 12.111328 15.998047 C 7.70352 20.405855 7.0561745 26.855003 10.660156 30.458984 L 481.54102 501.33984 C 485.145 504.94383 491.59414 504.29648 496.00195 499.88867 L 499.88867 496.00195 C 504.29648 491.59414 504.94383 485.145 501.33984 481.54102 L 448 428.20117 L 448 48 C 448 21.49 426.5 0 400 0 L 112 0 z M 64 121.79883 L 64 464 C 64 490.5 85.49 512 112 512 L 400 512 C 414.83427 512 428.08978 505.26554 436.89453 494.69336 L 326.20117 384 L 160 384 C 151.164 384 144 376.836 144 368 C 144 323.8 179.8 288 224 288 L 230.20117 288 L 64 121.79883 z M 256 128 C 291.35 128 320 156.65 320 192 C 320 221.32681 300.25749 245.98369 273.35352 253.55469 L 194.45117 174.65234 C 202.03661 147.77122 226.71897 128 256 128 z M 311.25977 291.46094 C 336.72898 299.19243 356.80757 319.27102 364.53906 344.74023 L 311.25977 291.46094 z ',
        },
        child: [],
        tag: 'path',
      },
    ],
    tag: 'svg',
  })(props);

export default UfpbImagePortraitSlash;
